import { ICommunicationError } from "@dev/hc-talk-talk";
import ContractWithdrawalIdentifyRequest from "@/app/dto/ContractWithdrawalIdentifyRequest";
import ContractWithdrawalTerminateRequest from "@/app/dto/ContractWithdrawalTerminateRequest";
import IContractWithdrawalIdentifyResponse from "@/app/dto/IContractWithdrawalIdentifyResponse";
import ApiError from "@/app/model/ApiError";
import OtpData from "@/app/model/OtpData";
import Api from "@/app/service/api";

class ContractWithdrawal {
    public identify(name: string, lastName: string, contractNumber: string): Promise<IContractWithdrawalIdentifyResponse> {
        return new Promise((resolve, reject) => {
            Api.contractWithdrawalIdentify(new ContractWithdrawalIdentifyRequest(name.trim(), lastName.trim(), contractNumber.trim()))
                .then((response: any) => {
                    resolve(response);
                })
                .catch((error: ICommunicationError) => {
                    reject(new ApiError(error));
                });
        });
    }

    public terminate(token: string, authKey: string, otp: OtpData, contractNumber: string): Promise<void> {
        return new Promise((resolve, reject) => {
            Api.contractWithdrawalTerminate(token, authKey, otp, new ContractWithdrawalTerminateRequest(contractNumber))
                .then((response: any) => {
                    resolve();
                })
                .catch((error: ICommunicationError) => {
                    reject(new ApiError(error));
                });
        });
    }
}

export default new ContractWithdrawal();
